export const FAQ_API_URLS = {
  FETCH_FAQ: '/faq',
  FETCH_FAQ_CATEGORIES: '/fetch-faq-categories',
  SAVE_FAQ: '/save-faq/',
  FETCH_FAQ_LIST: '/fetch-all-faq/',
  DELETE_FAQ: (questionId: string) => `/remove-faq/?questionid=${questionId}`,
  FETCH_SINGLE_FAQ: (questionId: string) => `/fetch-all-faq/?questionid=${questionId}`,
};
export default FAQ_API_URLS;